import Vuex from 'vuex';
import Vue from 'vue';
import mainStore from './modules/mainStore';
import detailStore from './modules/detailStore';
import widgetStore from './modules/widgetStore';

Vue.use (Vuex);

export default new Vuex.Store ({
  modules: {
    mainStore,
    detailStore,
    widgetStore,
  },
});
